const initialState = {
    pickupDate: '',
    pickupTime: '',
};

export default (state = initialState, action) => {
    switch (action.type) {
        case 'CLEAR_PICKUP_DATE':
            return {
                ...state,
                pickupDate: action.pickupDate,
            };

        // GET
        case 'PICKUP_OPTIONS_LOADING':
            return {
                ...state,
                isLoading: true,
            };

        case 'PICKUP_OPTIONS_ERROR':
            return {
                ...state,
                isLoading: false,
                error: action.err,
            };

        case 'PICKUP_OPTIONS_SUCCESS':
            // console.log(action.data);
            return {
                ...state,
                max_days: action.data.max_days,
                max_appointments: action.data.max_appointments,
                days: action.data.days,
                closed: action.data.closed,
                // pickupSettings: action.data,
                isLoading: false,
            };

        // SET
        case 'PICKUP_SELECTION_LOADING':
            return {
                ...state,
                selectionError: null,
                selectionLoading: true,
            };

        case 'PICKUP_SELECTION_ERROR':
            return {
                ...state,
                selectionLoading: false,
                selectionError: action.err,
            };

        case 'PICKUP_SELECTION_SUCCESS':
            return {
                ...state,
                selectionLoading: false,
            };

        case 'SET_PICKUP':
            const pickupDate = action.selection.pickupDate;
            return {
                ...state,
                pickupDate: pickupDate,
                isLoading: false,
            };

        case 'SET_PICKUP_SAVING':
            return {
                ...state,
                saving: true,
            };

        case 'SET_PICKUP_SAVED':
            return {
                ...state,
                saving: false,
            };

        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/store/reducers/pickup.js